import { Stack } from '#core/components';
import { SearchIcon as SearchIconBase } from '#core/components/icons';

export const SearchIcon = () => {
  return (
    <Stack alignItems="center" h={8} justifyContent="center" w={8}>
      <SearchIconBase />
    </Stack>
  );
};
